import { TransactionType } from 'types/advancePayment';

export const transactionTypeOptions = [
  { key: TransactionType.PAYOUT, value: 'Wypłata' },
  { key: TransactionType.PAYMENT, value: 'Wpłata' },
];
